















import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender } from "../model/Model";

@Component
export default class RisksAnalysisBlurb extends Vue {
  @Prop() public gender!: Gender;
  @Prop() public isLowerRisk!: boolean;
  @Prop() public commissioned!: boolean;

  private get isFemale(): boolean {
    return this.gender === Gender.Female;
  }

  private get isMale(): boolean {
    return this.gender === Gender.Male;
  }
}
